import React, { useState } from 'react';

import { useAppInfo } from 'AppState';
import Modal from 'components/Modal/Modal';
import {
  useLocation,
  useNavigate,
} from 'react-router-dom';

import MenuIcon from '@mui/icons-material/Menu';
import {
  Button,
  IconButton,
  Typography,
  useMediaQuery,
} from '@mui/material';

import Logo from '../logo/Logo';

export default function NavLanding() {
  const navigate = useNavigate()
  const location = useLocation()
  const page = location.pathname.split("/")[1]
  const pageHome = ["Home", "", "home"].includes(page)
  const { dispatchApp, dispatchHome } = useAppInfo()
  const isMobile = useMediaQuery('(max-width:600px)') // Define breakpoint for mobile screens
  const [menuOpen, setMenuOpen] = useState(false)

  function handleLogin(login = true) {
    dispatchApp({ "loginModal": login })
  }

  function handleRequestDemo() {
    dispatchHome({ "contactUs": true })
  }

  function handleNavigate(v) {
    navigate(`/${v}`)
    setMenuOpen(false) // Close the menu after navigation
  }

  function toggleDrawer(open) {
    setMenuOpen(open)
  }

  const topNavLinks = [
    // {name:"About",link:"About"},
    {name:"Contact",link:"Contact"}]

  return (
    <div className="nav_landing">
      <div className="nav_wrapper_landing" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      
      <div style={{ display: "flex",padding:"0.5rem",gap:"0.2rem"}}>
          <Logo color='black' width="135px"  height='25px' type='long' />
          <Typography className='gradient_text' 
          style={{alignSelf:"flex-start",fontSize:"0.9rem"}}>Beta</Typography>
        </div>
        {isMobile ? (
          <>
            <IconButton onClick={() => toggleDrawer(true)} edge="start">
              <MenuIcon />
            </IconButton>
            {menuOpen && (
            <Modal
              onClose={() => toggleDrawer(false)}
            >
              <div style={{ 
                width: '100%', 
                height: '100%', 
                display: 'flex', 
                flexDirection: 'column',
                padding: '0.5rem',
                gap: '2rem',boxSizing:"border-box"
              }}>
                <div style={{ 
                  display: 'flex', 
                  justifyContent: 'space-between', 
                  alignItems: 'center',
                  paddingBottom: '2rem',
                }}>
                  <div style={{ display: "flex",padding:"0.5rem",gap:"0.2rem"}}>
          <Logo color='black' width="135px"  height='25px' type='long' />
          <Typography className='gradient_text' 
          style={{alignSelf:"flex-start",fontSize:"0.9rem"}}>Beta</Typography>
        </div>
                  {/* <IconButton onClick={() => toggleDrawer(false)}>
                    <CloseIcon />
                  </IconButton> */}
                </div>
{/*                 
                <List sx={{ flex: 1 }}>
                  {topNavLinks.map((obj) => (
                    <ListItem 
                      key={obj.name} 
                      onClick={() => handleNavigate(obj.link)} 
                      sx={{ 
                        padding: '1rem 0',
                        '&:hover': {
                          backgroundColor: 'rgba(0,0,0,0.04)'
                        }
                      }}
                    >
                      <ListItemText 
                        primary={obj.name} 
                        sx={{ 
                          color: obj.link === page ? "var(--selectBlue)" : "black",
                          fontWeight: obj.link === page ? "bold" : "normal",
                          textAlign: 'center',
                          fontSize: '1.2rem'
                        }} 
                      />
                    </ListItem>
                  ))}
                </List> */}

                <div style={{ 
                  display: 'flex', 
                  flexDirection: 'column', 
                  gap: '1rem',
                  padding: '2rem',
                }}>
                  <Button 
                    onClick={handleLogin} 
                    variant='contained' 
                    sx={{
                      borderRadius: '25px',
                      background: 'var(--bgWoodSmoke)',
                      padding: '0.8rem'
                    }}
                  >
                    Login
                  </Button>
                  <Button 
                    variant='outlined' 
                    onClick={handleRequestDemo} 
                    sx={{
                      borderRadius: '25px',
                      color: 'black',
                      border: '1px solid black',
                      padding: '0.8rem'
                    }}
                  >
                    Request Demo
                  </Button>
                </div>
              </div>
            </Modal>
            )}
          </>
        ) : (
          <div style={{ display: "flex", flex: 1, gap: "2rem", alignItems: "center",justifyContent:"center", position: "relative", paddingLeft: "2rem" }}>
            {/* {topNavLinks.map(obj => (
              <Typography
                className='nav-link'
                onClick={() => handleNavigate(obj.link)}
                key={obj.name}
                style={{
                  cursor: "pointer",
                  color: obj.link === page && "var(--selectBlue)",
                  fontWeight: obj.link === page && "bold"
                }}>{obj.name}</Typography>
            ))} */}
          </div>
        )}
        {(!isMobile) && (
          <div style={{ marginLeft: "auto", display: "flex", gap: "1rem" }}>
            <Button onClick={handleLogin} variant='contained' sx={{borderRadius:"25px",background:"var(--bgWoodSmoke)"}}>Login</Button>
            <Button variant='outlined'  onClick={handleRequestDemo} sx={{borderRadius:"25px",color:"black",border:"1px solid black"}}>Request Demo</Button>
          </div>
        )}
      </div>
    </div>
  )
}

// import { Button, Typography } from '@mui/material'
// import React from 'react'
// import Logo from '../logo/Logo'
// import { useAppInfo } from 'AppState'
// import { useLocation, useNavigate } from 'react-router-dom'

// export default function NavLanding() {
//     const navigate = useNavigate()
//     const location = useLocation()
//     const page = location.pathname.split("/")[1]
//     const {dispatchApp,dispatchHome} = useAppInfo()
//     function handleLogin(login=true){
//         dispatchApp({"loginModal":login})
//       }
  
//       function handleRequestDemo(){
//         dispatchHome({"contactUs":true})
//       }

//     function handleNavigate(v){
//         navigate(`/${v}`)
//     }
    
  
//   return (
//     <div className="nav_landing">
//     <div className="nav_wrapper_landing">
        
//         <div className='gradient_text' style={{display:"flex",gap:"0.5rem"}}>
//             <Logo height='25px' width="150px" type='long'/>
//             <Typography>Beta</Typography>
//         </div>
//         <div style={{display:"flex",flex:1,gap:"2rem",alignItems:"center"
//         ,position:"relative",paddingLeft:"2rem"}}>
//           {["Features","About","Contact"].map(obj=>
//           <Typography 
//           onClick={()=>handleNavigate(obj)}
//           key={obj} 
//           style={{cursor:"pointer",color:obj===page ? 
//           "var(--selectBlue)":"black",fontWeight:obj===page && "bold"}}>{obj}</Typography>)}
        
//         </div>
//         <div style={{ marginLeft: "auto", display: "flex", gap: "1rem" }}>
//             <Button onClick={handleLogin} color="success" variant='contained'>Login</Button>
//             <Button 
//             variant='outlined'
//             onClick={handleRequestDemo}
//            >Request Demo</Button>
//         </div>
//     </div>
// </div>
//   )
// }
